import ModelAjax from "../ajax/modelAjax";

const ID_MODAL = '#modal';
const ID_MODAL_CLOSE = '#modal__close';
const CLASS_MODAL_TRIGGER = '.modal__trigger';
const doc = document;
const modal = doc?.querySelector(ID_MODAL);
const model = new ModelAjax();
let obj;

const CLASS_MODAL_HEADLINE = '.modal__metadata--headline';
const CLASS_MODAL_TEASER = '.modal__metadata--teaser';
const CLASS_MODAL_TEXT = '.modal__metadata--text';
const CLASS_MODAL_PRICE = '.modal__metadata--price';
const CLASS_MODAL_IMAGE = '.modal__image';
const ID_MODAL_BUTTON = '#modal-offer-button';

export default class Modal {
    
  constructor() {  
    obj = this;
    let triggerArray = doc.querySelectorAll(CLASS_MODAL_TRIGGER);

    triggerArray.forEach(function (trigger, index) {
        trigger.addEventListener('click', obj.open);
    })

    doc.querySelector(ID_MODAL_CLOSE)?.addEventListener('click', this.close);
    doc.querySelector(ID_MODAL)?.addEventListener('click', this.close);
  }

  open(id = false) {
    let dataId = this.getAttribute('data-bonus');
    let buttonEl = doc.querySelector(ID_MODAL_BUTTON);
    modal.style.display = 'block';
    model.getDataById('bonus', dataId).then(function(val) { 
      doc.querySelector(CLASS_MODAL_HEADLINE).innerHTML = val.title;
      doc.querySelector(CLASS_MODAL_IMAGE).setAttribute('src', val.thumbnail_url);
      doc.querySelector(CLASS_MODAL_TEXT).innerHTML = val.text;
      buttonEl.setAttribute('data-selection', val.artikelnummer);
      buttonEl.setAttribute('data-id', val.id);   
      
      if(obj.getCookie('dataSelection') != val.artikelnummer){
        buttonEl.classList.remove('button--selected');
        //buttonEl.classList.add('button--icon');
        doc.querySelector(ID_MODAL_BUTTON).innerHTML = "Prämie auswählen";        
      }else{
        buttonEl.classList.add('button--selected');
        //buttonEl.classList.remove('button--icon');
        buttonEl.innerHTML = "Prämie ausgewählt";
      }
    });
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  close() {
    modal.style.display = 'none';
  }

}